// @ts-nocheck
// tool-app-stack-payback.js — App Stack Payback behaviour (SSM-631 / SSM-636).
//
// Math ported verbatim from the Vercel app's src/lib/appStackPayback.ts. Writes values
// into markup that snippets/tool-app-stack-payback.liquid already rendered, and reveals
// one of the four pre-rendered result states.
//
// Two exceptions to "never build DOM", both data rather than copy: the chart's geometry
// and the month-by-month table rows, whose count depends on the chosen horizon.
(function () {
  var roots = document.querySelectorAll('[data-tool="app_stack_payback"]');
  if (!roots.length) return;

  // ── Chart geometry. Must stay in step with the viewBox in the Liquid. ──────
  var W = 640;
  var H = 300;
  var PAD = { top: 14, right: 58, bottom: 26, left: 54 };
  var PLOT_W = W - PAD.left - PAD.right; // 528
  var PLOT_H = H - PAD.top - PAD.bottom; // 260

  function xAt(month, horizon) {
    return PAD.left + (month / horizon) * PLOT_W;
  }

  function yAt(value, maxV) {
    return PAD.top + PLOT_H - (value / maxV) * PLOT_H;
  }

  // ── Formatting ────────────────────────────────────────────────────────────
  function usd(n) {
    return n.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    });
  }

  // Round before formatting, so a displayed "$0" always means the underlying figure
  // rounded to zero — which is what the copy branches on.
  function money(n) {
    return isFinite(n) ? usd(Math.round(n)) : usd(0);
  }

  // Axis and end-of-line labels only; full precision lives in the table. Millions need
  // their own suffix or a 36-month enterprise stack reads as "$3600k".
  function compactUsd(n) {
    var sign = n < 0 ? '-' : '';
    var v = Math.abs(Math.round(n));
    if (v >= 1000000) {
      var m = v / 1000000;
      return sign + '$' + (v % 1000000 === 0 ? m.toFixed(0) : m.toFixed(1)) + 'm';
    }
    if (v >= 1000) {
      var k = v / 1000;
      return sign + '$' + (v % 1000 === 0 ? k.toFixed(0) : k.toFixed(1)) + 'k';
    }
    return sign + '$' + v;
  }

  function parseNum(raw) {
    var cleaned = String(raw).replace(/[^0-9.]/g, '');
    if (cleaned === '') return null;
    var n = Number(cleaned);
    return isFinite(n) && n >= 0 ? n : null;
  }

  function numOr0(raw) {
    var n = parseNum(raw);
    return n == null ? 0 : n;
  }

  function plural(n) {
    return n === 1 ? 'one' : 'many';
  }

  function mount(root) {
    if (root.dataset.toolMounted) return;
    root.dataset.toolMounted = 'true';

    var MIN_MARGIN = Number(root.getAttribute('data-min-margin'));
    if (!isFinite(MIN_MARGIN)) return;

    var fields = {};
    root.querySelectorAll('[data-asp-input]').forEach(function (el) {
      fields[el.getAttribute('data-asp-input')] = el;
    });
    if (!fields.appSpend || !fields.buildCost || !fields.maint) return;

    var out = {};
    root.querySelectorAll('[data-asp-out]').forEach(function (el) {
      out[el.getAttribute('data-asp-out')] = el;
    });

    var notes = {};
    root.querySelectorAll('[data-asp-note]').forEach(function (el) {
      notes[el.getAttribute('data-asp-note')] = el;
    });

    var headlines = {};
    root.querySelectorAll('[data-asp-headline]').forEach(function (el) {
      headlines[el.getAttribute('data-asp-headline')] = el;
    });

    var sublines = {};
    root.querySelectorAll('[data-asp-subline]').forEach(function (el) {
      sublines[el.getAttribute('data-asp-subline')] = el;
    });

    var chart = {};
    root.querySelectorAll('[data-asp-chart]').forEach(function (el) {
      chart[el.getAttribute('data-asp-chart')] = el;
    });

    var svg = root.querySelector('.tool-asp__chart');
    var tbody = root.querySelector('[data-asp-tbody]');
    var tableWrap = root.querySelector('[data-asp-table-wrap]');
    var toggle = root.querySelector('[data-asp-toggle]');
    var copyBtn = root.querySelector('[data-asp-copy]');
    var statusEl = root.querySelector('[data-asp-status]');

    // Segmented controls: the buttons themselves are the option list.
    var segments = { buildMonths: null, horizon: null };
    Object.keys(segments).forEach(function (name) {
      var btns = root.querySelectorAll('[data-asp-seg="' + name + '"]');
      var active = null;
      btns.forEach(function (b) {
        if (b.getAttribute('aria-pressed') === 'true') active = Number(b.getAttribute('data-value'));
      });
      segments[name] = { buttons: btns, value: active };
    });
    if (segments.buildMonths.value == null || segments.horizon.value == null) return;

    var copyTimer = null;
    var last = null;

    // ── The model (src/lib/appStackPayback.ts) ─────────────────────────────
    function appsCumulative(i, m) {
      return i.appSpend * m;
    }

    // Three components: the build, the app fees that keep running until launch, and
    // upkeep from launch onward. The middle term is the one naive models drop.
    function buildCumulative(i, m) {
      return (
        i.buildCost +
        i.appSpend * Math.min(m, i.buildMonths) +
        i.maint * Math.max(0, m - i.buildMonths)
      );
    }

    function monthlyMargin(i) {
      return i.appSpend - i.maint;
    }

    // Guard order matters and is asserted with !(x > 0) so NaN falls into the branch.
    function breakevenMonth(i) {
      if (!(i.appSpend > 0)) return { month: null, exact: null, reason: 'no-spend' };

      var margin = monthlyMargin(i);
      if (!(margin >= MIN_MARGIN)) return { month: null, exact: null, reason: 'no-margin' };

      var exact = i.buildMonths + i.buildCost / margin;
      if (!isFinite(exact)) return { month: null, exact: null, reason: 'no-margin' };

      // Ceiling, not round: the first whole month actually ahead. Epsilon so a
      // crossover landing on a boundary is not pushed to the following month.
      var month = Math.max(i.buildMonths, Math.ceil(exact - 1e-9));
      if (month > i.horizon) return { month: null, exact: null, reason: 'beyond-horizon' };
      return { month: month, exact: exact, reason: null };
    }

    function computePayback(i) {
      var be = breakevenMonth(i);
      var series = [];
      for (var m = 0; m <= i.horizon; m++) {
        series.push({ month: m, apps: appsCumulative(i, m), build: buildCumulative(i, m) });
      }
      var appsAtHorizon = appsCumulative(i, i.horizon);
      var buildAtHorizon = buildCumulative(i, i.horizon);

      return {
        breakeven: be.month,
        reason: be.reason,
        breakevenExact: be.exact,
        appsAtHorizon: appsAtHorizon,
        buildAtHorizon: buildAtHorizon,
        netSaved: appsAtHorizon - buildAtHorizon,
        monthlyMargin: monthlyMargin(i),
        series: series
      };
    }

    // ── Helpers ────────────────────────────────────────────────────────────
    function set(key, value) {
      if (out[key]) out[key].textContent = value;
    }

    function note(key, visible) {
      if (notes[key]) notes[key].hidden = !visible;
    }

    function reveal(map, activeKey) {
      Object.keys(map).forEach(function (k) {
        map[k].hidden = k !== activeKey;
      });
    }

    function readInputs() {
      return {
        appSpend: numOr0(fields.appSpend.value),
        buildCost: numOr0(fields.buildCost.value),
        buildMonths: segments.buildMonths.value,
        maint: numOr0(fields.maint.value),
        horizon: segments.horizon.value
      };
    }

    function linePath(series, key, horizon, maxV) {
      var d = '';
      for (var i = 0; i < series.length; i++) {
        d +=
          (i === 0 ? 'M' : ' L') +
          xAt(series[i].month, horizon).toFixed(1) +
          ',' +
          yAt(series[i][key], maxV).toFixed(1);
      }
      return d;
    }

    function drawChart(i, r) {
      if (!svg) return;
      var lastPoint = r.series[r.series.length - 1];
      // The `1` floor keeps an all-zero form producing finite paths.
      var maxV = Math.max(lastPoint.apps, lastPoint.build, 1) * 1.12;

      if (chart.buildWindow) {
        var show = i.buildMonths > 0 && i.buildMonths <= i.horizon;
        chart.buildWindow.setAttribute(
          'width',
          show ? String(xAt(i.buildMonths, i.horizon) - PAD.left) : '0'
        );
      }

      [0, 0.5, 1].forEach(function (f, idx) {
        var y = yAt(maxV * f, maxV);
        var line = root.querySelector('[data-asp-grid="' + idx + '"]');
        var label = root.querySelector('[data-asp-ylabel="' + idx + '"]');
        if (line) {
          line.setAttribute('y1', String(y));
          line.setAttribute('y2', String(y));
        }
        if (label) {
          label.setAttribute('y', String(y + 3.5));
          label.textContent = compactUsd(maxV * f);
        }
      });

      var xTicks = [0, Math.round(i.horizon / 2), i.horizon];
      xTicks.forEach(function (m, idx) {
        var label = root.querySelector('[data-asp-xlabel="' + idx + '"]');
        if (!label) return;
        label.setAttribute('x', String(xAt(m, i.horizon)));
        label.textContent = 'mo ' + m;
      });

      if (chart.appsPath) chart.appsPath.setAttribute('d', linePath(r.series, 'apps', i.horizon, maxV));
      if (chart.buildPath) chart.buildPath.setAttribute('d', linePath(r.series, 'build', i.horizon, maxV));

      if (chart.marker) {
        if (r.breakevenExact !== null) {
          chart.marker.hidden = false;
          var mx = xAt(r.breakevenExact, i.horizon);
          if (chart.markerLine) {
            chart.markerLine.setAttribute('x1', String(mx));
            chart.markerLine.setAttribute('x2', String(mx));
          }
          if (chart.markerDot) {
            chart.markerDot.setAttribute('cx', String(mx));
            chart.markerDot.setAttribute('cy', String(yAt(i.appSpend * r.breakevenExact, maxV)));
          }
        } else {
          chart.marker.hidden = true;
        }
      }

      // End-of-line dots and labels, nudged apart when they would collide.
      var ex = xAt(i.horizon, i.horizon);
      var ya = yAt(lastPoint.apps, maxV);
      var yb = yAt(lastPoint.build, maxV);
      var collide = Math.abs(ya - yb) < 14;
      var yaL = collide ? (ya <= yb ? ya - 7 : ya + 7) : ya;
      var ybL = collide ? (ya <= yb ? yb + 7 : yb - 7) : yb;

      if (chart.appsDot) {
        chart.appsDot.setAttribute('cx', String(ex));
        chart.appsDot.setAttribute('cy', String(ya));
      }
      if (chart.buildDot) {
        chart.buildDot.setAttribute('cx', String(ex));
        chart.buildDot.setAttribute('cy', String(yb));
      }
      if (chart.appsEnd) {
        chart.appsEnd.setAttribute('x', String(ex + 8));
        chart.appsEnd.setAttribute('y', String(yaL + 3.5));
        chart.appsEnd.textContent = compactUsd(lastPoint.apps);
      }
      if (chart.buildEnd) {
        chart.buildEnd.setAttribute('x', String(ex + 8));
        chart.buildEnd.setAttribute('y', String(ybL + 3.5));
        chart.buildEnd.textContent = compactUsd(lastPoint.build);
      }

      svg.setAttribute(
        'aria-label',
        'Cumulative cost over ' +
          i.horizon +
          ' months. Renting the apps reaches ' +
          money(r.appsAtHorizon) +
          '; building reaches ' +
          money(r.buildAtHorizon) +
          '. ' +
          (r.breakeven !== null
            ? 'The lines cross in month ' + r.breakeven + '.'
            : 'The lines do not cross inside this horizon.')
      );
    }

    function drawTable(i, r) {
      if (!tbody) return;
      // Rows thin out to roughly a dozen so 36 months still reads at a glance, but the
      // breakeven row is always kept: the caption sends people here to check it.
      var step = Math.max(1, Math.round(i.horizon / 12));
      var rows = r.series.filter(function (p) {
        return p.month % step === 0 || p.month === i.horizon || p.month === r.breakeven;
      });

      var html = '';
      for (var n = 0; n < rows.length; n++) {
        var p = rows[n];
        var diff = p.apps - p.build;
        var ahead = diff >= 0;
        html +=
          '<tr>' +
          '<td>Month ' + p.month + '</td>' +
          '<td>' + money(p.apps) + '</td>' +
          '<td>' + money(p.build) + '</td>' +
          '<td data-sign="' + (ahead ? 'ahead' : 'behind') + '">' +
          (ahead ? '' : '-') + money(Math.abs(diff)) +
          '</td>' +
          '</tr>';
      }
      tbody.innerHTML = html;
    }

    function render() {
      var i = readInputs();
      var r = computePayback(i);
      last = { inputs: i, result: r };

      var state = r.breakeven !== null ? 'found' : r.reason || 'no-spend';
      reveal(headlines, state);
      reveal(sublines, state);

      set('breakevenMonth', r.breakeven === null ? '—' : String(r.breakeven));
      set('breakevenMonth2', r.breakeven === null ? '—' : String(r.breakeven));
      set('horizonH', String(i.horizon));
      set('horizonH2', String(i.horizon));
      set('horizonT', String(i.horizon));
      set('margin', money(r.monthlyMargin));
      set('margin2', money(r.monthlyMargin));
      set('appSpend', money(i.appSpend));
      set('appSpend2', money(i.appSpend));
      set('appSpend3', money(i.appSpend));
      set('maint', money(i.maint));
      set('maint2', money(i.maint));
      set('buildCost', money(i.buildCost));
      set('buildMonths', String(i.buildMonths));
      set('buildMonths2', String(i.buildMonths));
      set('buildMonths3', String(i.buildMonths));

      var ahead = r.netSaved >= 0;
      note('net-saved', ahead);
      note('net-behind', !ahead);
      set('netSaved', money(Math.abs(r.netSaved)));
      if (out.netSaved) out.netSaved.setAttribute('data-sign', ahead ? 'ahead' : 'behind');
      set('appsAtHorizon', money(r.appsAtHorizon));
      set('buildAtHorizon', money(r.buildAtHorizon));

      // Clamped so a negative margin shows $0 while the headline still says it never
      // pays back.
      set('marginTile', money(Math.max(0, r.monthlyMargin)));
      set('overlap', money(i.appSpend * i.buildMonths));

      var one = plural(i.buildMonths) === 'one';
      note('month-one', one);
      note('month-many', !one);
      note('foot-month-one', one);
      note('foot-month-many', !one);

      drawChart(i, r);
      drawTable(i, r);
    }

    // ── Worked example: always the DEFAULTS, never the live inputs ─────────
    function renderExample() {
      var d = {
        appSpend: Number(root.getAttribute('data-default-app-spend')),
        buildCost: Number(root.getAttribute('data-default-build-cost')),
        buildMonths: Number(root.getAttribute('data-default-build-months')),
        maint: Number(root.getAttribute('data-default-maint')),
        horizon: Number(root.getAttribute('data-default-horizon'))
      };
      if (!isFinite(d.appSpend) || !isFinite(d.buildCost)) return;

      var r = computePayback(d);
      var margin = d.appSpend - d.maint;
      var overlap = d.appSpend * d.buildMonths;

      var eg = {};
      root.querySelectorAll('[data-asp-eg]').forEach(function (el) {
        eg[el.getAttribute('data-asp-eg')] = el;
      });
      function put(k, v) {
        if (eg[k]) eg[k].textContent = v;
      }

      put('appSpend', money(d.appSpend));
      put('appSpend2', money(d.appSpend));
      put('appSpend3', money(d.appSpend));
      put('buildCost', money(d.buildCost));
      put('buildCost2', money(d.buildCost));
      put('buildCost3', money(d.buildCost));
      put('maint', money(d.maint));
      put('maint2', money(d.maint));
      put('maint3', money(d.maint));
      put('margin', money(margin));
      put('margin2', money(margin));
      put('overlap', money(overlap));
      put('recovery', (d.buildCost / margin).toFixed(1));
      put('crossover', (d.buildMonths + d.buildCost / margin).toFixed(1));
      put('breakeven', r.breakeven === null ? '—' : String(r.breakeven));
      put('apps', money(r.appsAtHorizon));
      put('build', money(r.buildAtHorizon));
      put('net', money(Math.abs(r.netSaved)));
      put('netWord', r.netSaved >= 0 ? 'saved' : 'still behind');
    }

    function copySummary() {
      if (!last || !navigator.clipboard) return;
      var i = last.inputs;
      var r = last.result;

      var lines = [
        'App Stack Payback - Shero Commerce',
        '',
        'Monthly app spend replaced: ' + money(i.appSpend),
        'One-time build estimate: ' + money(i.buildCost),
        'Build timeline: ' + i.buildMonths + ' month' + (i.buildMonths === 1 ? '' : 's'),
        'Upkeep after launch: ' + money(i.maint) + '/mo',
        'Horizon: ' + i.horizon + ' months',
        '',
        r.breakeven !== null
          ? 'Breakeven: month ' + r.breakeven
          : 'Breakeven: none inside ' + i.horizon + ' months',
        'Renting the apps for ' + i.horizon + ' months: ' + money(r.appsAtHorizon),
        'Building instead: ' + money(r.buildAtHorizon),
        'Net ' +
          (r.netSaved >= 0 ? 'saved' : 'behind') +
          ' over ' +
          i.horizon +
          ' months: ' +
          money(Math.abs(r.netSaved)),
        '',
        'Model only. A real build cost comes from a discovery call.',
        'https://sherocommerce.com'
      ];

      navigator.clipboard.writeText(lines.join('\n')).then(function () {
        copyBtn.textContent = '✓ Copied!';
        copyBtn.classList.add('tool__btn--copied');
        if (statusEl) statusEl.textContent = 'Result summary copied to clipboard.';
        clearTimeout(copyTimer);
        copyTimer = setTimeout(function () {
          copyBtn.textContent = 'Copy result summary';
          copyBtn.classList.remove('tool__btn--copied');
          if (statusEl) statusEl.textContent = '';
        }, 2500);
      });
    }

    // ── Wiring ─────────────────────────────────────────────────────────────
    Object.keys(fields).forEach(function (key) {
      fields[key].addEventListener('input', render);
    });

    Object.keys(segments).forEach(function (name) {
      segments[name].buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          segments[name].value = Number(btn.getAttribute('data-value'));
          segments[name].buttons.forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          render();
        });
      });
    });

    if (toggle && tableWrap) {
      toggle.addEventListener('click', function () {
        var open = tableWrap.hidden;
        tableWrap.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        note('table-show', !open);
        note('table-hide', open);
      });
    }

    if (copyBtn) copyBtn.addEventListener('click', copySummary);

    render();
    renderExample();
  }

  // Marked only after a clean mount, so free-tools.liquid reveals its fallback table if setup throws.
  for (var r = 0; r < roots.length; r++) {
    mount(roots[r]);
    roots[r].setAttribute('data-tool-ready', '');
  }
})();
